var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4987 15.5H13.1858V10.803V10.7969C13.1859 10.2001 13.1859 9.39379 12.9274 8.73769C12.7921 8.39411 12.5773 8.06611 12.2364 7.82742C11.8944 7.58792 11.4682 7.46837 10.9629 7.46837C10.4663 7.46837 10.0386 7.56576 9.68151 7.76393C9.32155 7.96367 9.0633 8.24924 8.88309 8.57669C8.53562 9.20809 8.47347 10.0065 8.47347 10.7128V15.4997H6.1607V5.81248H8.34096V6.77299V7.27299H8.84096H8.88548H9.17253L9.31727 7.02509C9.87291 6.07339 10.9057 5.50544 12.0047 5.5463L12.014 5.54665H12.0233C13.5786 5.54665 14.3877 6.0482 14.8476 6.77892C15.3408 7.56269 15.5 8.70889 15.5 10.1371C15.5 10.1371 15.5 10.1372 15.5 10.1372L15.4987 15.5ZM1.9227 3.35162C1.13793 3.35176 0.500141 2.71434 0.5 1.92606C0.499859 1.13779 1.13742 0.500141 1.92219 0.5C2.70696 0.499859 3.34474 1.13727 3.34489 1.92555C3.34495 2.30398 3.19494 2.66676 2.92813 2.93413C2.66135 3.20148 2.29967 3.35155 1.9227 3.35162ZM3.07917 5.81248V15.5H0.762951V5.81248H3.07917Z",
    fill: "#A8C956",
    stroke: "#A8C956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a1a74108a4ad4cf8d7bf4fae02ef9890.svg";
export { ForwardRef as ReactComponent };